<template>
  <section class="page-section">
    <div class="metric-grid">
      <el-card class="metric-card" shadow="hover">
        <p>总申领单数量</p>
        <strong>{{ dashboard.metrics.totalRequests }}</strong>
        <span class="metric-note">{{ dashboard.metrics.totalRequests ? '当前企业累计申领单总数' : '当前还没有申领记录' }}</span>
      </el-card>
      <el-card class="metric-card" shadow="hover">
        <p>总通过数量</p>
        <strong>{{ dashboard.metrics.approvedCount }}</strong>
        <span class="metric-note">{{ dashboard.metrics.approvedCount ? '已完成审批通过的申领单数量' : '当前没有审批通过记录' }}</span>
      </el-card>
      <el-card class="metric-card" shadow="hover">
        <p>总申领成本</p>
        <strong>¥ {{ totalCostText }}</strong>
        <span class="metric-note">{{ dashboard.metrics.totalCost ? '仅统计已审批通过的申领成本' : '暂无可统计的申领成本' }}</span>
      </el-card>
    </div>

    <div class="chart-grid">
      <EChartCard
        title="月度申领趋势"
        subtitle="近 6 个月申领单数量"
        :option="trendOption"
        :empty="trendEmpty"
        :empty-text="trendEmptyText"
      />
      <EChartCard
        title="热门用品 Top 5"
        subtitle="按申领数量排序"
        :option="topOption"
        :empty="topEmpty"
        :empty-text="topEmptyText"
      />
      <EChartCard
        title="申领成本分布"
        subtitle="按用品成本占比"
        :option="costOption"
        :empty="costEmpty"
        :empty-text="costEmptyText"
      />
    </div>
  </section>
</template>

<script>
import { fetchAdminDashboard } from '../../services/adminService'
import EChartCard from '../EChartCard.vue'

export default {
  name: 'AdminDashboardPanel',
  components: {
    EChartCard
  },
  data() {
    return {
      dashboard: {
        metrics: {
          totalRequests: 0,
          approvedCount: 0,
          totalCost: 0
        },
        trend: [],
        topSupplies: [],
        costDistribution: []
      }
    }
  },
  computed: {
    totalCostText() {
      return Number(this.dashboard.metrics.totalCost ?? 0).toFixed(2)
    },
    trendEmpty() {
      const trend = this.dashboard.trend || []
      return !trend.length || !trend.some((item) => Number(item.value) > 0)
    },
    trendEmptyText() {
      if (!this.dashboard.trend?.length) {
        return '暂无趋势数据'
      }

      return '数据不足，暂无法形成趋势图'
    },
    topEmpty() {
      const list = this.dashboard.topSupplies || []
      return !list.length || !list.some((item) => Number(item.value) > 0)
    },
    topEmptyText() {
      return '暂无热门用品排行数据'
    },
    costEmpty() {
      const list = this.dashboard.costDistribution || []
      return !list.length || !list.some((item) => Number(item.value) > 0)
    },
    costEmptyText() {
      return '暂无成本分布数据'
    },
    trendOption() {
      return {
        color: ['#2563eb'],
        tooltip: { trigger: 'axis' },
        grid: { left: 24, right: 20, top: 30, bottom: 24 },
        xAxis: {
          type: 'category',
          data: this.dashboard.trend.map((item) => item.label)
        },
        yAxis: { type: 'value' },
        series: [
          {
            data: this.dashboard.trend.map((item) => item.value),
            type: 'line',
            smooth: true,
            areaStyle: { color: 'rgba(37, 99, 235, 0.16)' }
          }
        ]
      }
    },
    topOption() {
      return {
        color: ['#0f766e'],
        tooltip: { trigger: 'axis' },
        grid: { left: 24, right: 20, top: 30, bottom: 24 },
        xAxis: {
          type: 'category',
          axisLabel: { rotate: 20 },
          data: this.dashboard.topSupplies.map((item) => item.name)
        },
        yAxis: { type: 'value' },
        series: [
          {
            type: 'bar',
            barWidth: 28,
            data: this.dashboard.topSupplies.map((item) => item.value),
            itemStyle: { borderRadius: [8, 8, 0, 0] }
          }
        ]
      }
    },
    costOption() {
      return {
        tooltip: { trigger: 'item' },
        legend: { bottom: 0 },
        series: [
          {
            type: 'pie',
            radius: ['42%', '68%'],
            data: this.dashboard.costDistribution,
            label: { formatter: '{b}\n{d}%' }
          }
        ]
      }
    }
  },
  mounted() {
    this.loadDashboard()
  },
  methods: {
    async loadDashboard() {
      const response = await fetchAdminDashboard()
      this.dashboard = response.data || {
        metrics: {
          totalRequests: 0,
          approvedCount: 0,
          totalCost: 0
        },
        trend: [],
        topSupplies: [],
        costDistribution: []
      }
    }
  }
}
</script>

<style scoped>
.page-section {
  display: grid;
  gap: 22px;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.metric-card {
  border-radius: 22px;
}

.metric-card p {
  margin: 0;
  color: #64748b;
}

.metric-card strong {
  display: block;
  margin-top: 16px;
  font-size: 34px;
  color: #0f172a;
}

.metric-note {
  display: block;
  margin-top: 12px;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

.chart-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
}

.chart-grid > :last-child {
  grid-column: 1 / -1;
}

@media (max-width: 1200px) {
  .metric-grid,
  .chart-grid {
    grid-template-columns: 1fr;
  }
}
</style>
